module.exports = __webpack_public_path__ + "img/air_switch_off.4d3f7989.png";